export type System = (dt: number) => void;

export interface LoopOptions {
  /** Clamp dt máximo por tick en ms. Default 100ms (evita spirals tras tab inactiva). */
  maxFrameMs?: number;
  /** Si > 0, el loop usa accumulator fixed-step y cada sistema recibe stepMs. */
  stepMs?: number;
}

export class Loop {
  private readonly systems: System[] = [];
  private readonly maxFrameMs: number;
  private readonly stepMs: number;
  private accumulator = 0;
  private paused = false;

  constructor(opts: LoopOptions = {}) {
    this.maxFrameMs = opts.maxFrameMs ?? 100;
    this.stepMs = opts.stepMs ?? 0;
  }

  add(system: System): void {
    this.systems.push(system);
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
  }

  isPaused(): boolean {
    return this.paused;
  }

  tick(deltaMs: number): void {
    if (this.paused) return;
    const dt = Math.min(deltaMs, this.maxFrameMs);
    if (this.stepMs > 0) {
      this.accumulator += dt;
      while (this.accumulator >= this.stepMs) {
        this.runSystems(this.stepMs);
        this.accumulator -= this.stepMs;
      }
    } else {
      this.runSystems(dt);
    }
  }

  private runSystems(dt: number): void {
    for (const system of this.systems) {
      system(dt);
    }
  }
}
